import React from "react";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";



export const DateLabelFormatter = ({dateString}) => {

    return (
        <span>{dateString && moment(dateString).format('DD.MM.YYYY')}</span>
    )
};





